module.exports = __webpack_public_path__ + "img/d200801-5.9215bd63.jpg";